/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ComplaintTOListResponse } from '../models/complaint-tolist-response';
import { ComplaintTOResponse } from '../models/complaint-toresponse';
import { ComplaintForm } from '../models/complaint-form';

/**
 * Complaint Controller
 */
@Injectable({
  providedIn: 'root',
})
class ComplaintControllerService extends __BaseService {
  static readonly listUsingGET6Path = '/api/v1/complain/list';
  static readonly createUsingPOSTPath = '/api/v1/complain/send';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * List complaints
   * @param params The `ComplaintControllerService.ListUsingGET6Params` containing the following parameters:
   *
   * - `status`: status
   *
   * - `reason`: reason
   *
   * - `dateTo`: dateTo
   *
   * - `dateFrom`: dateFrom
   *
   * @return OK
   */
  listUsingGET6Response(params: ComplaintControllerService.ListUsingGET6Params): __Observable<__StrictHttpResponse<ComplaintTOListResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.dateTo != null) __params = __params.set('dateTo', params.dateTo.toString());
    if (params.dateFrom != null) __params = __params.set('dateFrom', params.dateFrom.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/complain/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ComplaintTOListResponse>;
      })
    );
  }
  /**
   * List complaints
   * @param params The `ComplaintControllerService.ListUsingGET6Params` containing the following parameters:
   *
   * - `status`: status
   *
   * - `reason`: reason
   *
   * - `dateTo`: dateTo
   *
   * - `dateFrom`: dateFrom
   *
   * @return OK
   */
  listUsingGET6(params: ComplaintControllerService.ListUsingGET6Params): __Observable<ComplaintTOListResponse> {
    return this.listUsingGET6Response(params).pipe(
      __map(_r => _r.body as ComplaintTOListResponse)
    );
  }

  /**
   * Create complaint
   * @param form form
   * @return OK
   */
  createUsingPOSTResponse(form: ComplaintForm): __Observable<__StrictHttpResponse<ComplaintTOResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = form;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/v1/complain/send`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ComplaintTOResponse>;
      })
    );
  }
  /**
   * Create complaint
   * @param form form
   * @return OK
   */
  createUsingPOST(form: ComplaintForm): __Observable<ComplaintTOResponse> {
    return this.createUsingPOSTResponse(form).pipe(
      __map(_r => _r.body as ComplaintTOResponse)
    );
  }
}

module ComplaintControllerService {

  /**
   * Parameters for listUsingGET6
   */
  export interface ListUsingGET6Params {

    /**
     * status
     */
    status?: 'ACCEPTED' | 'DECLINED' | 'EMAIL_SENT' | 'IN_PROGRESS' | 'UNRECOGNIZED' | 'UNRECOGNIZED_STATUS';

    /**
     * reason
     */
    reason?: 'INVALID_GEO' | 'INVALID_NAME' | 'OTHER' | 'UNRECOGNIZED' | 'UNRECOGNIZED_REASON';

    /**
     * dateTo
     */
    dateTo?: string;

    /**
     * dateFrom
     */
    dateFrom?: string;
  }
}

export { ComplaintControllerService }
